/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 29/07/2025.
 */
import { Alert, Button, Input } from 'antd'
import { DrawerContainer } from '../../components/drawer/DrawerContainer'
import { DEVICE_STATE, DEVICE_STATE_TYPE } from '../../Types'
import React, { useState } from 'react'
import { COLOR } from '../../constants'
import { FormLabel } from '../../components/form/FormLabel'

import { useParams } from 'react-router-dom'
import { ENDPOINTS } from '../../service/ENDPOINTS'
import { post } from '../../service/API'
import { useFadeIn } from '../../components/animation/useFadeIn'

const { TextArea } = Input

type Props = {
  projectStatus: string
  deviceState: DEVICE_STATE_TYPE
  deviceId?: string
  mutateSubjectData: () => void
}

export const SubjectLostDevice = ({
  projectStatus,
  deviceState,

  deviceId,
  mutateSubjectData,
}: Props) => {
  const [state, setState] = useState(false)
  if (
    deviceState === DEVICE_STATE.WIPE_DEVICE ||
    deviceState === DEVICE_STATE.WIPED ||
    deviceState === DEVICE_STATE.ENROLL_NEW_DEVICE
  ) {
    return null
  }

  const drawerStateChange = (value) => {
    setState(value)
  }

  return (
    <div className="col-12 mt-4 px-4 py-4 rounded-3" style={{ background: COLOR.LIGHT_GRAY }}>
      <h5 className="mb-3 mt-1">Lost Device</h5>

      <p>
        This will remotely lock the lost device to prevent unauthorized access and start the replacement process.
        Unsynced data will be inaccessible, protecting health data if found by others.
      </p>

      <Button
        onClick={() => {
          setState(!state)
        }}
        className="px-5 mt-3"
        size="large"
        danger
        disabled={projectStatus !== 'ACTIVE'}
      >
        Report a Lost Device
      </Button>
      {state ? (
        <DrawerContainer projectId={'projectId'} setVisible={drawerStateChange} width={480} to="" title=" ">
          <ConfirmLostDevice
            deviceId={deviceId}
            onClose={() => {
              console.log('SubjectReplaceDevice > tried to close =')
            }}
            mutateSubjectData={mutateSubjectData}
          ></ConfirmLostDevice>
        </DrawerContainer>
      ) : null}
    </div>
  )
}

const ConfirmLostDevice = ({ onClose, deviceId, mutateSubjectData }) => {
  const { animated, spring } = useFadeIn()

  const { projectId, subjectId } = useParams() as { projectId: string; subjectId: string }
  const [justification, setJustification] = useState<string>('')
  const [screeningidInput, setScreeningidInput] = useState<string>('')
  const [screeningIdError, setScreeningIdError] = useState<string>('')
  const [error, setError] = useState<string>('')
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [serverError, setServerError] = useState<boolean>(false)

  const handleJustificationChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (error.length > 0) {
      setError('')
    }

    setJustification(e.target.value)
  }

  const handleScreeningIdChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (error.length > 0) {
      setScreeningIdError('')
    }

    setScreeningidInput(e.target.value)
  }

  const checkInputFields = () => {
    if (screeningidInput.length < 3) {
      setScreeningIdError('Please provide a valid screening ID for this action')
    }

    if (justification.length < 3) {
      setError('Please provide a justification for this action')
    }

    return justification.length < 3 || screeningidInput.length < 3
  }

  const confirmWipe = () => {
    setServerError(false)

    if (isLoading) {
      return
    }

    if (checkInputFields()) {
      console.log('SubjectLostDevice > stop  = ')
      return null
    }

    setIsLoading(true)
    const obj = {
      projectId: projectId,
      subjectId: subjectId,
      deviceId: deviceId,
      reason: justification,
      screeningId: screeningidInput,
    }

    const path = ENDPOINTS.SUBJECTS.lostDevice(projectId)
    post(path, obj)
      .then((res) => {
        setIsLoading(false)
        mutateSubjectData()
      })
      .catch((err) => {
        setIsLoading(false)
        console.log('DeviceDetails > err = ', err)

        setServerError(true)
      })
  }

  return (
    <animated.div style={spring} className="">
      <div className="">
        <h3 className="mb-3 ">Report and wipe a lost device</h3>
        <p className="opacity-75">
          You are about to report the device as lost. The device cannot be synchronised, and any unsynchronised data
          will be permanently lost.
        </p>

        <h6 className="fw-bold  mt-4">Once confirmed:</h6>
        <p className="opacity-75">Continuing an participants will need a new device to resume study</p>
      </div>

      <div>
        <h6 className="fw-bold mt-4 ">To complete this action:</h6>
        <p className="opacity-75">
          Please confirm the action by providing the screening ID of the participant and a written justification
        </p>
        <div className="mt-3">
          <FormLabel label="Screening Id:"></FormLabel>
          <Input
            placeholder="Screening Id"
            status={screeningIdError ? 'error' : ''}
            onChange={handleScreeningIdChange}
          />
          {screeningIdError ? <p className="text-danger">{screeningIdError}</p> : null}
        </div>
        <div className="mt-3">
          <FormLabel label="Provide Justification:"></FormLabel>
          <TextArea placeholder="" status={error ? 'error' : ''} rows={2} onChange={handleJustificationChange} />
          {error ? <p className="text-danger">{error}</p> : null}
        </div>
        <div className="d-flex justify-content-end mt-3">
          <div className="">
            <Button className="ms-2" type="default" onClick={onClose}>
              Cancel
            </Button>
            <Button className="ms-2" danger type="primary" onClick={confirmWipe} loading={isLoading}>
              Confirm lost device
            </Button>
          </div>
        </div>
      </div>

      <div className="mt-2">
        {serverError ? (
          <Alert
            className="w-100"
            message={<p className="fw-bold mb-0">Action was not succesfull</p>}
            description={
              <p>Incorrect screening ID. Make sure capital and lowercase letters match exactly. Please try again.</p>
            }
            type="error"
          />
        ) : null}
      </div>
    </animated.div>
  )
}
